module.exports = __webpack_public_path__ + "static/img/logo-bg.7b7d69e6.png";